import { combineReducers } from 'redux';
import authReducer from './users';

const rootReducer = combineReducers({
    auth: authReducer,
});

export default rootReducer;
